export const INIT_AUDIT_DATA = 'INIT_AUDIT_DATA';
export const GET_AUDIT_HEADER_TO_DISPLAY = 'GET_AUDIT_HEADER_TO_DISPLAY';
export const GET_AUDIT_COLUMNS = 'GET_AUDIT_COLUMNS';

export const FETCH_RESULTS = 'FETCH_RESULTS';
export const FETCH_EXISTING_RESULTS = 'FETCH_EXISTING_RESULTS';

//Global actions
export const SET_SITES_PER_USER = 'SET_SITES_PER_USER';
export const SITES_BY_LOGGED_IN_USER = 'SITES_BY_LOGGED_IN_USER';
